import { CircularProgress } from '@mui/material';
import './ActionButton.css';

interface Props {
  label?: string;
  icon?: React.ReactNode;
  isLoading?: boolean;
  isDisabled?: boolean;
  onPress: () => void;
  children?: React.ReactNode;
}

const ActionButton = ({
  label,
  icon,
  isLoading,
  isDisabled,
  onPress,
  children,
}: Props) => {
  const finalOnPress = !isDisabled && !isLoading ? onPress : undefined;
  return (
    <div
      className={`action-button ${isDisabled ? 'disabled' : ''}`}
      onClick={finalOnPress}
    >
      {isLoading ? (
        <CircularProgress size={24} sx={{ color: 'white' }} />
      ) : (
        <>
          {icon && <div className="icon-container">{icon}</div>}
          {children || <div className="label">{label}</div>}
        </>
      )}
    </div>
  );
};

export default ActionButton;
